module.exports = class PaymentsListCtrl
  constructor: ->
    'ngInject'

  paymentClass: (payment) ->
    "payments-list__tr_#{payment.appointment.state}"
